import { selectors as sessionSelectors } from '@mulesoft/exchange-ui-portals-store/lib/domains/session';
import { selectors as commonSelectors } from '~/domains/common';
import { REUSE_METRICS_ENABLED } from '~/domains/featureFlags/keys';
import { isLoggedIn } from '~/utils/validations/profile';

const resolve = async ({ getState }) => {
  const state = getState();
  const profile = commonSelectors.profile(state);
  const isReuseMetricsEnabled = sessionSelectors.featureFlag(
    state,
    REUSE_METRICS_ENABLED
  );
  const isAssetUsageAndEngagementEnabled = sessionSelectors.entitlement(
    state,
    'exchange2',
    'assetUsageAndEngagement'
  );

  isLoggedIn(profile);

  if (!isReuseMetricsEnabled || !isAssetUsageAndEngagementEnabled) {
    const error = new Error('Page not enabled');

    error.status = 404;

    throw error;
  }
};

export default resolve;
